import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, Button, } from '@mui/material';
import { Alert, CardBody, Spinner, Form } from 'reactstrap';
import { toast } from 'react-toastify';
import { api } from '../../services/api';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';

const PagoTicModal = ({ open, onClose, loading }) => {
  const param = useParams();
  const [showForm, setShowForm] = useState(false);
  const [credentials, setCredentials] = useState([]);
  const [selectedCredential, setSelectedCredential] = useState("");
  const [loadingCredentials, setLoadingCredentials] = useState(false);
  const [formData, setFormData] = useState({
    nombre: '',
    username: '',
    password: '',
    client_id: '',
    client_secret: ''
  });

  useEffect(() => {
    if (open) {
      loadCredentials();
    }
  }, [open]);

  const loadCredentials = async () => {
    setLoadingCredentials(true);
    try {
      const response = await api.pagotic.getCredential();
      if (response.status === "success") {
        setCredentials(response.data);
      }
    } catch (error) {
      toast.error("Error al cargar las credenciales");
    } finally {
      setLoadingCredentials(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      let response;
      
      if (showForm) {
        response = await api.pagotic.createCredential(formData);
        if (response.status === "success") {
          const assignResponse = await api.pagotic.assignCredential({
            idevento: parseInt(param?.id),
            idcredencial: response.data.id
          });
          
          if (assignResponse.status === "success") {
            toast.success("Credencial creada y asignada exitosamente");
            onClose();
          }
        }
      } else {

        response = await api.pagotic.assignCredential({
          idevento: parseInt(param?.id),
          idcredencial: parseInt(selectedCredential)
        });
        
        if (response.status === "success") {
          toast.success("Credencial asignada exitosamente");
          onClose();
        }
      }
    } catch (error) {
      toast.error(error.message || "Error al procesar la solicitud");
    }
  };

  const handleClose = () => {
    setShowForm(false);
    setSelectedCredential('');
    setFormData({
      nombre: '',
      username: '',
      password: '',
      client_id: '',
      client_secret: ''
    });
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{padding:"16px 24px 10px !important", color:"#5656FF", fontSize:"20px", fontWeight:"600"}}>
        {showForm ? "Nueva credencial PagoTIC" : "Seleccionar credencial PagoTIC"}
      </DialogTitle>
      <DialogContent>
        {!showForm ? (
          <div className="mt-3">
            {loadingCredentials ? (
              <div className="text-center">
                <Spinner color="primary" />
              </div>
            ) : (
              <>
                <select
                  className="form-select mb-2"
                  value={selectedCredential}
                  onChange={(e) => setSelectedCredential(e.target.value)}
                >
                  <option value="">Seleccionar credencial...</option>
                  {credentials.map(cred => (
                    <option key={cred.id} value={cred.id}>
                      {cred.nombre}
                    </option>
                  ))}
                </select>
                <div className="d-flex justify-content-between mt-4">
                  <Button
                    variant="outlined"
                    sx={{borderColor: "#5656FF", color: "#5656FF"}}
                    onClick={() => setShowForm(true)}
                  >
                    Crear nueva credencial
                  </Button>
                  <Button
                    variant="contained"
                    disabled={!selectedCredential || loading}
                    onClick={handleSave}
                  >
                    {loading ? <Spinner size="sm" /> : 'Asignar credencial'}
                  </Button>
                </div>
              </>
            )}
          </div>
        ) : (
          <Form onSubmit={handleSave} className="mt-3">
            <div className="mb-3">
              <label className="form-label">Nombre de la credencial</label>
              <input
                type="text"
                className="form-control"
                name="nombre"
                value={formData.nombre}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Username</label>
              <input
                type="text"
                className="form-control"
                name="username"
                value={formData.username}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Password</label>
              <input
                type="password"
                className="form-control"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Client ID</label>
              <input
                type="text"
                className="form-control"
                name="client_id"
                value={formData.client_id}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Client Secret</label>
              <input
                type="password"
                className="form-control"
                name="client_secret"
                value={formData.client_secret}
                onChange={handleChange}
                required
              />
            </div>
            <div className="d-flex justify-content-between mt-4">
              <Button
                variant="outlined"
                sx={{borderColor: "#5656FF", color: "#5656FF"}}
                onClick={() => setShowForm(false)}
              >
                Volver
              </Button>
              <Button
                variant="contained"
                type="submit"
                sx={{backgroundColor: "#5656FF", color: "white"}} 
                disabled={loading}
              >
                {loading ? <Spinner size="sm" /> : 'Guardar credencial'}
              </Button>
            </div>
          </Form>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default PagoTicModal;